export default {
  appid: 165,
  vip: {
    actid: "xiaozhanhuiyuan",
    pid: "xz_12m_dl_99y_vip",
  },
};
